<section class="block preview-brief">
  @if (loading && !challenge) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else if (error && !challenge) {
    <p class="empty">{{ error }}</p>
    <button mat-stroked-button type="button" (click)="reload()">Try Again</button>
  } @else if (challenge) {
    <div class="preview-actions">
      <button mat-stroked-button type="button" (click)="reload()" [disabled]="loading">
        {{ loading ? 'Refreshing…' : 'Refresh preview' }}
      </button>
    </div>
    <div class="preview-frame">
      <app-career-challenge-brief
        [challenge]="challenge"
        mode="preview"
        [showFreeRemediationBenefit]="showFreeRemediationBenefit"
      />
    </div>
  }
</section>